<header>
    <div class="wrapper">
        <div class="user platform">

            <div class="top-menu users" *ngIf="userMenuOpen">
                
                <!--<div class="top-menu-item">
                    <div class="img user-profile"></div>
                    <div class="item-text">
                        <p>@Translations.UserProfile</p>
                    </div>
                </div>

                <div class="top-menu-item">
                    <div class="img system-settings"></div>
                    <div class="item-text">
                        <p>@Translations.SystemSettings</p>
                    </div>
                </div>-->


                <a href="/account/logout">
                    <div class="top-menu-item">
                        <div class="img logout"></div>
                        <div class="item-text">
                            <p>Logout</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        
        <div class="empty"></div>

        <div class="language-picker platform">
            <p (click)="openCloseLangMenu()">{{'HOME.APP_CURRLANG' | translate}}</p>

            <div class="top-menu" *ngIf="langMenuOpen">
                
                <div class="top-menu-item" *ngFor = "let lang of translateService.getLangs()">
                    <div class="item-text" (click)="translateService.use(lang)">
                        <p>{{lang}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
